import type { FaresByKeyModel } from "@/models/JourneySelectorViewModel";

export function getFareForFareKey(fareKey: string, fares: FaresByKeyModel[]): FaresByKeyModel {
    const selected = fares.find((fare) => fare.key === fareKey);
    return selected!;
}
